import { useState } from 'react'
import { ConfirmationDialog } from '@/components/patterns/confirmation-dialog'
import { useActionMenu } from './ActionsMenu'

const ActionWithConfirmation = ({ trigger, onConfirm, isPending, ...props }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const { row, setIsDropdownOpen } = useActionMenu()

  const handleOpenDialog = (isOpen) => {
    // Close dropdown menu when dialog closes
    if (!isOpen) setIsDropdownOpen(false)

    setIsDialogOpen(isOpen)
  }
  return (
    <ConfirmationDialog
      trigger={trigger}
      open={isDialogOpen}
      onOpenChange={handleOpenDialog}
      onConfirm={async (e) => {
        e.preventDefault()
        // Always make it a promise (that way we always await it)
        // So the dialog will be closed after the work is done
        await Promise.resolve(onConfirm?.(row))
        handleOpenDialog(false)
      }}
      isPending={isPending}
      {...props}
    />
  )
}

export default ActionWithConfirmation
